import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getSessionCompanyId } from '../../selectors/session';
import { CompanyFeatureConfig } from '../interfaces/feature-count';
import { createGlobalState } from '../react-query/createGlobalState';
import { ReactQueryKeys } from '../react-query-keys';

const useCompanyFeatureConfigCache = createGlobalState<
  Record<string, CompanyFeatureConfig>
>(ReactQueryKeys.featureConfig(), null);

export default function useGetFeatureConfig() {
  const companyId = useSelector(getSessionCompanyId);
  const {
    data,
    setData: setCacheData,
    resetData,
  } = useCompanyFeatureConfigCache();

  const setData = useCallback(
    (featureConfig: CompanyFeatureConfig) => {
      setCacheData(previousData => ({
        ...previousData,
        [companyId]: featureConfig,
      }));
    },
    [companyId, setCacheData]
  );

  return { data: data?.[companyId], setData, resetData };
}
